import { useCallback, useEffect, useState, useRef } from 'react';
import { getAppointmentTrends } from 'api/home';
import { TAppointmentTrendItem, TAppointmentTrendRequest } from 'types/home';

const useGetAppointmentTrends = (
    params: TAppointmentTrendRequest,
    autoFetch: boolean = true
): [TAppointmentTrendItem[], boolean, (newParams?: TAppointmentTrendRequest) => void] => {
    const [data, setData] = useState<TAppointmentTrendItem[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const paramsRef = useRef(params);

    // 更新 params ref
    useEffect(() => {
        paramsRef.current = params;
    }, [params]);

    const fetch = useCallback(
        async (newParams?: TAppointmentTrendRequest) => {
            setLoading(true);
            try {
                const requestParams = newParams || paramsRef.current;
                const res = await getAppointmentTrends(requestParams);

                if (res && !res.error) {
                    setData(res.data?.data || []);
                } else {
                    setData([]);
                }
            } catch (e) {
                console.error('Failed to fetch appointment trends:', e);
                setData([]);
            } finally {
                setLoading(false);
            }
        },
        []
    );

    useEffect(() => {
        if (autoFetch) {
            fetch();
        }
    }, [autoFetch, params.start, params.end, fetch]);

    return [data, loading, fetch];
};

export default useGetAppointmentTrends;

